import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services-final-cta-section',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './services-final-cta-section.component.html',
  styleUrl: './services-final-cta-section.component.scss'
})
export class ServicesFinalCtaSectionComponent {}
